export const getUserDetails = () => {
  const userDetails = JSON.parse(localStorage.getItem("auth"));
  return userDetails;
};

export const getLocalAppSettings = () => {
  const appSettings = localStorage.getItem("appSettings");
  if (!appSettings) {
    return {
      isAllowCleanerPaymentSettings: false,
      isAllowJobProviderPaymentSettings: false,
      isPlatformPaymentActive: false,
    };
  }
  return JSON.parse(appSettings);
};
